;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('DeskfyLoaderController', DeskfyLoaderController)

  /* @ngInject */
  function DeskfyLoaderController () {}
})()
